import { Dispatch, SetStateAction, useEffect, useState } from 'react';

export default function useLocalStorage<TData>(key: string): [TData, Dispatch<SetStateAction<TData>>] {
  const parseJsonSafely = (value: string | null): any => {
    try {
      if (value === null) return null;
      return JSON.parse(value);
    } catch {
      if (typeof value !== 'object') return value;
      return null;
    }
  };

  const [state, setState] = useState<TData>(() => {
    const value = localStorage.getItem(key);
    return parseJsonSafely(value);
  });

  useEffect(() => {
    const listenStorageChange = () => {
      const value = localStorage.getItem(key);
      setState(parseJsonSafely(value));
    };

    window.addEventListener('storage', listenStorageChange);
    return () => {
      window.removeEventListener('storage', listenStorageChange);
    };
  }, [key]);

  const setLocalStorageState = (newValue: any) => {
    if (newValue === null || newValue === undefined) {
      localStorage.removeItem(key);
    } else {
      const valueToStore =
        (typeof newValue === 'object' && true)
          ? JSON.stringify(newValue) // Armazena como JSON string se for objeto ou array
          : newValue;
      localStorage.setItem(key, valueToStore);
    }
    return setState(newValue);
  };

  return [state, setLocalStorageState] as const;
}
